import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../_components/common/Navbar/index';
import { Button as StrapButton } from 'reactstrap';

import './index.css'
import ModalComponent from '../../_components/common/Modal';
import { homePageAction } from '../../_actions';
import { headerPermissionAction } from '../../_actions/Analyze/headerPermission.action'
import { orgAdminAction, saveTeamDetailsAction, saveModulePermissionsAction, analyseActions } from '../../_actions';



const Button = (props) => {
    const { link, name, val, id } = props
    if(val !== undefined) {
        if(localStorage.getItem("is_success_main") == "true") {
            var primaryLink = `${link}/${val.id}/super-admin`
        }
        else if(localStorage.getItem("is_org_admin_main") == "true") {
            var primaryLink = `${link}/${val.id}/org-admin`
        }
        else if(localStorage.getItem("is_pa_user_main") == "true") {
            var primaryLink = `${link}/${val.id}/user`
        }
    }
    return (
        id == '' ?
            <button className="button" style={props.style} onClick={() => props.onClick()}>
                {name}
            </button> :
            <Link to={{
                pathname: primaryLink,
                state: val.id
            }}
            >
                <button onClick={()=>props.onClickOrg(val.organisation_name,id)} className="button" style={props.style}>
                    {name}
                </button>
            </Link>
    ); ``
}

class HomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            addOrgModal: false,
            // organisations: [
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "1"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "2"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "3"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "4"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "5"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "6"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "7"
            //     },
            //     {
            //         orgName: 'ABC',
            //         link: "/organisation",
            //         id: "8"
            //     }

            // ]
        }
    }

    componentDidMount() {
        this.props.dispatch(homePageAction.getOrgHandler(() => { }));
        this.props.dispatch(homePageAction.getCountryListHandler());
        
        this.props.dispatch(analyseActions.saveAssessorIds(''))
        this.props.dispatch(analyseActions.saveAssessorGroups(''))

    }



    toggleEntireOrgModal(showModal) {
        this.setState({
            addOrgModal: showModal
        })
    }

    actionSelected(data) {
        this.props.dispatch(homePageAction.addOrgHandler(data, () => { }));
    }

    onClickOrg = (name,id) => {
        this.props.dispatch({type: "RELOAD_FALSE"})
        localStorage.setItem('orgName',name)
        this.props.dispatch(headerPermissionAction.headerPermissionDataAction({"analytics_org_id": id},(callback_data) => {
            if(callback_data.data !== '') {
                localStorage.setItem('is_org_admin',callback_data.data.is_org_admin)
                localStorage.setItem('is_pa_user',callback_data.data.is_pa_user)
                localStorage.setItem('is_success',callback_data.data.is_super_admin)
                if(callback_data.data.is_pa_user == true) {
                    this.props.history.push(`/organisation/${id}/user`)
                }else if(callback_data.data.is_org_admin == true) {
                    this.props.history.push(`/organisation/${id}/org-admin`)
                }else if(callback_data.data.is_super_admin == true) {
                    this.props.history.push(`/organisation/${id}/super-admin`)
                }
            }
        }))
    }


    render() {
        const { getCountryListResponse, getOrgResponse, getOrgLoading, getCountryListLoading, getCountryListError } = this.props;
        const addOrg = [{
            key: 'org_name',
            type: 'text',
            value: '',
            valid: false,
            elementConfig: {
                name: 'org_name',
                label: 'Name',
                placeholder: 'Team Name Pvt Ltd'
            },
            validation: {
                required: true,
                message: "is required"
            },

        },
        {
            key: 'country_id',
            type: 'select',
            value: '',
            valid: false,
            elementConfig: {
                name: 'country_name',
                label: 'Country',
                options: getCountryListResponse,
            },
            validation: {
                required: true,
                message: "is required"
            }
        }
        ]
        return (
            <div className="home-page-container">
                <Navbar navItems={[]} />
                < div className="">
                    <div className="" style={{ height: 50 }}>

                    </div>
                    <div className="">
                        <h1 className="text-white text-center heading-para pb-5 font-weight-bold">Choose Organisation</h1>
                        {
                            getOrgResponse === '' ?
                                <React.Fragment>
                                    {
                                        localStorage.getItem("is_success_main") == "true" ?
                                        <div className="d-flex flex-row flex-wrap justify-content-center">
                                            <div className="d-flex flex-row  justify-content-center px-0 m-4 py-2">
                                                <Button name={'Add Organisation +'} link={''} id={''} onClick={() => this.setState({ addOrgModal: true })} style={{ width: 150, height: 100, backgroundColor: 'rgb(52, 141, 89)', color: '#fff', fontSize: 18,cursor: 'pointer' }} customComponent={<div>hi</div>} />
                                            </div>
                                        </div>:
                                        null
                                    }
                                </React.Fragment>
                                :
                                    <div style={{ 
                                        margin: '0rem 11rem',
                                        display: 'grid',
                                        gridTemplateColumns: 'auto auto auto auto',
                                        padding: '0 4rem'
                                    }}>
                                    <React.Fragment>
                                {
                                    localStorage.getItem("is_success_main") == "true" ?
                                    <div className="d-flex flex-row  justify-content-center   px-0 m-4 py-2">
                                        <Button name={'Add Organisation +'} link={''} id={''} onClick={() => this.setState({ addOrgModal: true })} style={{ marginLeft: 10, marginRight: 10, width: 150, height: 100, backgroundColor: 'rgb(52, 141, 89)', color: '#fff', fontSize: 18,cursor: 'pointer', whiteSpace: 'normal' }} />
                                    </div>:
                                    null
                                }
                                </React.Fragment>
                                    {
                                        this.state.addOrgModal &&
                                        <ModalComponent
                                            showModal={this.state.addOrgModal}
                                            heading="Add Organisation"
                                            formData={addOrg}
                                            action={this.actionSelected.bind(this)}
                                            toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                            footerFormSubmitButton={['Add', 'Cancel']}
                                            selectKey={['id']}
                                            selects={['country_name']}
                                        />
                                    }
                                    {
                                        getCountryListLoading === false && getOrgResponse !== '' ?
                                        getOrgResponse.map(
                                            (val, key) => {
                                                return <div className="d-flex flex-row  justify-content-center  px-0 m-4 py-2" key={key}>
                                                    <StrapButton onClick = {()=>this.onClickOrg(val.organisation_name, val.id)} className="button" style={{ width: 150, height: 100, backgroundColor: 'rgb(53, 120, 160)', border: 0, color: '#fff', fontSize: 18,cursor: 'pointer', whiteSpace: 'normal' }}>{val.organisation_name}</StrapButton>
                                                </div>
                                            })
                                        :
                                        null
                                    }
                                </div>
                        }
                    </div>
                    {
                        getCountryListLoading && getCountryListError === false ?
                            <p className="text-center my-3 text-white">
                                <i className="fas fa-spinner fa-spin " ></i>
                                &nbsp;loading
                            </p> 
                        :
                            null
                    }
                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    const { getCountryListLoading } = state.getCountryListReducer;
    const getCountryListError = state.getCountryListReducer.error;
    const getCountryListResponse = (!getCountryListLoading && !getCountryListError) ? state.getCountryListReducer.data.data.country_list : '';

    const { getOrgLoading } = state.getOrgReducer;
    const getOrgError = state.getOrgReducer.error;
    const getOrgResponse = (!getOrgLoading && !getOrgError) ? state.getOrgReducer.data.data.organisation_list : ''
    return {
        getCountryListLoading,
        getCountryListError,
        getCountryListResponse,

        getOrgLoading,
        getOrgResponse
    };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };


// WEBPACK FOOTER //
// ./src/_pages/HomePage/index.js